(function () {
  angular
    .module('kareo.ui.shared.directives.provider.k-provider-types', [
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.modules.api.provider.k-provider-type-service'
    ])
    .component('kProviderTypes', {
      bindings: {
        availableProviderTypes: '<',
        providerInfo: '=',
        hasProviderType: '=',
        isBillingSelected: '=',
        isReadOnly: '<?',
        updateProviderTypes: '=',
        onProviderTypeChanged: '=',
        isClinicalSupervisorRoleFTEnabled: '<',
        isTebraPackage: '<'
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-provider-types.pug')()
    });
  
  const SUPERVISING_PROVIDERTYPEID = 11;

  controller.$inject = ['$scope', 'kProviderTypeService'];
  function controller($scope, kProviderTypeService) {
    const vm = this;

    vm.$onInit = init;

    vm.allAvailableProviderTypes = [];
    vm.initialProviderTypeId = null;
    vm.initialTaxonomyCode = null;
    vm.isDisabled = false;

    // ------------------------------------------------------------------------

    function init() {
      vm.providerInfo = vm.providerInfo || {};
      vm.availableProviderTypes = [];
      vm.isBillingSelected = vm.isBillingSelected || false;
      vm.hasProviderType = vm.hasProviderType || false;
      vm.updateProviderTypes = vm.updateProviderTypes || false;
      vm.initialProviderTypeId = vm.providerInfo.providerTypeId;
      vm.initialTaxonomyCode = vm.providerInfo.taxonomyCode;
      vm.isDisabled = !vm.providerInfo.taxonomyCode || (!!vm.providerInfo.providerGuid && (vm.providerInfo.taxonomyCode === vm.initialTaxonomyCode)) || vm.isReadOnly;
      
      $scope.$watch('vm.updateProviderTypes', () => {
        if (vm.updateProviderTypes) {
          getUpdatedProviderTypes();
        }
      });

      $scope.$watch('vm.providerInfo.providerTypeId', (newValue, oldValue) => {
        if (!!vm.onProviderTypeChanged) {
          vm.onProviderTypeChanged(vm.initialProviderTypeId, newValue);
        }
      });

      getUpdatedProviderTypes();
    }

    function getUpdatedProviderTypes() {
      if (vm.providerInfo.taxonomyCode) {
        // make the call to to get the available provider types
        kProviderTypeService.getProviderTypesForProviderAndTaxonomyCode(vm.providerInfo.providerGuid, vm.providerInfo.taxonomyCode)
          .then((providerTypes) => {

            // update vm.availableProviderTypes
            if (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage && !!vm.initialProviderTypeId && vm.initialProviderTypeId != SUPERVISING_PROVIDERTYPEID){
              vm.availableProviderTypes = providerTypes.filter(providerType => providerType.typeId != SUPERVISING_PROVIDERTYPEID);
            } else {
              vm.availableProviderTypes = providerTypes;
            }

            if (vm.providerInfo.providerTypeId) {
              updateSelectedProviderType();
            }
            vm.isDisabled = !vm.providerInfo.taxonomyCode || (!!vm.providerInfo.providerGuid && (vm.providerInfo.taxonomyCode === vm.initialTaxonomyCode)) || vm.isReadOnly;
          });
        vm.updateProviderTypes = false;
      }
    }

    function updateSelectedProviderType() {
      // Restore selected providerTypeId if user changes taxonomy code and changes back to original
      if (!!vm.providerInfo.taxonomyCode && (vm.providerInfo.taxonomyCode === vm.initialTaxonomyCode)) {
        vm.providerInfo.providerTypeId = vm.initialProviderTypeId;
        hasSelectedProvider = true;
        updateProviderTypeName(-1);
        return;
      }

      var hasSelectedProvider = false;
      for (var i = 0; i < vm.availableProviderTypes.length; i++) {
        if (vm.availableProviderTypes[i].typeId === vm.providerInfo.providerTypeId) {
          hasSelectedProvider = true;
          updateProviderTypeName(i);
          break;
        }
      }
      // Need to remove the providerTypeId as it is no longer an available option
      if (!hasSelectedProvider) {
        delete vm.providerInfo.providerTypeId;
      }
    }

    function updateProviderTypeName(index) {
      if(index > -1 && vm.availableProviderTypes[i]){
        vm.providerInfo.providerTypeName = vm.availableProviderTypes[i].name;
        return;
      }
      for (var i = 0; i < vm.availableProviderTypes.length; i++) {
        if (vm.availableProviderTypes[i].typeId === vm.providerInfo.providerTypeId) {
          vm.providerInfo.providerTypeName = vm.availableProviderTypes[i].name;
          break;
        }
      }
    }

  }
})();
